<template>
  <header
    id="site-header"
    class="site-header content-max-width min-[1160px]:flex min-[1160px]:justify-between"
    :class="{ open: isOpen }"
  >
    <div class="flex justify-between">
      <a href="/" class="logo">
        <img src="/images/logo.svg" :alt="data.site_name" />
      </a>

      <div class="right">
        <button class="hamburger" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <nav class="flex flex-col min-[1160px]:flex-row min-[1160px]:items-center">
      <ul class="top">
        <!-- <li v-for="(link, index) of nav" :key="index">
          <a :href="link.url">
            {{ link.title }}
          </a>
        </li> -->
        <li
          class="min-[1160px]:hidden"
          :class="{ active: urlPath.length === 1 || urlPath.includes('home') }"
        >
          <a href="#">Home</a>
        </li>
        <li :class="{ active: urlPath.includes('about') }"><a href="/about-us">About Us</a></li>
        <li :class="{ active: urlPath.includes('what-we') }"><a href="/what-we-do">What We Do</a></li>
        <li :class="{ active: urlPath.includes('people') }"><a href="our-people">Our People</a></li>
        <li :class="{ active: urlPath.includes('news') }"><a href="/news">News</a></li>
        <li :class="{ active: urlPath.includes('events') }"><a href="/events">Events</a></li>
        <li :class="{ active: urlPath.includes('supporters') }">
          <a href="/supporters">Supporters</a>
        </li>
        <li :class="{ active: urlPath.includes('donations') }">
          <a href="/donations">Donations</a>
        </li>
      </ul>
      <div
        class="btn-wrap flex items-center justify-between order-first min-[1160px]:order-last min-[1160px]:ml-[39px]"
      >
        <a href="/contact-us" class="button type-orange">Contact Us</a>
        <a href="#" class="min-[1160px]:hidden" @click.prevent="toggleMenu">
          <span class="close-ico"></span>
        </a>
      </div>
    </nav>
    <div class="drawer-backdrop" @click="toggleMenu"></div>
  </header>
</template>

<script>
export default {
  name: 'HeaderCmpnt',

  props: {
    menu: Array,
    data: Object,
  },

  data: () => ({
    isOpen: false,
    nav: [],
    urlPath: '',
  }),

  mounted() {
    this.nav = this.menu
    this.urlPath = window.location.pathname
  },

  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
      if ((this.isOpen && this.urlPath.length === 1) || this.urlPath.includes('home'))
        this.$parent.$el.className = 'nav-open is-home'
      else if (this.isOpen) this.$parent.$el.className = 'nav-open'
      else this.$parent.$el.classList.remove('nav-open')
    },
  },
}
</script>
